import { render, staticRenderFns } from "./FullscreenTownSelect.vue?vue&type=template&id=d4e1cad8"
import script from "./FullscreenTownSelect.vue?vue&type=script&lang=ts"
export * from "./FullscreenTownSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports